export default "__VITE_ASSET__2461ff7c__"